import { getFormattedTimestamp } from "../../OrderCommon";

const initialState = {
  rfqId: "",
  proformaInvoiceId: "",
  personalDetails: {
    networkId: "",
    parentId: "",
    username: "",
    no: "",
    siteName: "",
    name: "",
    phoneNo: Number(),
    emailId: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: Number(),
    landmark: "",
    panNumber: "",
    latitude: Number(),
    longitude: Number(),
  },
  companyAdditionalInformation: {
    companyName: "",
    businessType: "",
    country: "",
    yearEstablished: "",
    numberOfEmployees: "",
    annualSalesRevenue: "",
    companyWebite: "",
    myCompanyHasNoWebite: Boolean(),
    panNumber: "",
    gstin_Number: "",
    companyDescription: "",
  },
  deliveryAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  supplierDetails: {
    supplierId: "",
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    emailId: "",
    phoneNo: "",
    latitude: Number(),
    longitude: Number(),
    panNumber: Number(),
    gstin_Number: "",
  },
  growerFarmingSiteAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: Number(),
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  assetDetails: [
    {
      assetVerticalId: "",
      assetVerticalFriendlyName: "",
      category: "",
      legacyAssetType: "",
      modelId: "",
      cn: "",
      hsn: "",
      labelInstructions: "",
      origin: "",
      description: "",
      quantity: "",
      unit: "",
      grade: "",
      price: "",
      discount: "",
      totalDiscountablePrice: Number(),
    },
  ],
  requirements: {
    assetPackage: "",
    transport: "",
    provenance: "",
    certificationLink: "",
    qualityGuidelineLink: "",
    optionalDocumentLink: "",
    fromDate: "",
    toDate: "",
  },
  totalAmount: Number(),
  paymentMode: "",
  requestType: "",
  timeStamp: getFormattedTimestamp(),
};

const transportasset = {
  rfqId: "",
  proformaInvoiceId: "",
  personalDetails: {
    networkId: "",
    parentId: "",
    username: "",
    no: "",
    siteName: "",
    name: "",
    phoneNo: Number(),
    emailId: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: Number(),
    landmark: "",
    panNumber: "",
    latitude: Number(),
    longitude: Number(),
  },
  companyAdditionalInformation: {
    companyName: "",
    businessType: "",
    country: "",
    yearEstablished: "",
    numberOfEmployees: "",
    annualSalesRevenue: "",
    companyWebite: "",
    myCompanyHasNoWebite: Boolean(),
    panNumber: "",
    gstin_Number: "",
    companyDescription: "",
  },
  deliveryAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: Number(),
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  supplierDetails: {
    supplierId: "",
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    emailId: "",
    phoneNo: "",
    latitude: Number(),
    longitude: Number(),
    panNumber: "",
    gstin_Number: "",
  },
  pickUpAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: Number(),
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  assetDetails: [
    {
      assetVerticalId: "",
      assetVerticalFriendlyName: "",
      category: "",
      legacyAssetType: "",
      modelId: "",
      cn: "",
      hsn: "",
      labelInstructions: "",
      description: "",
      grade: "",
      origin: "",
      quantity: "",
      unit: "",
      price: "",
      discount: "",
      totalDiscountablePrice: Number(),
    },
  ],
  transportDetails: {
    transportType: "",
    modeOfTransport: "",
    preferredTransportCompany: "",
  },
  requirements: {
    assetPackage: "",
    vehicleInsurance: "",
    agreement: "",
    transportGuideLineLink: "",
    optionalDocumentLink: "",
    fromDate: "",
    toDate: "",
  },
  totalAmount: Number(),
  paymentMode: "",
  requestType: "",
  timeStamp: getFormattedTimestamp(),
};

const storageasset = {
  rfqId: "",
  proformaInvoiceId: "",
  personalDetails: {
    networkId: "",
    parentId: "",
    username: "",
    no: "",
    siteName: "",
    name: "",
    phoneNo: Number(),
    emailId: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: Number(),
    landmark: "",
    panNumber: "",
    latitude: Number(),
    longitude: Number(),
  },
  companyAdditionalInformation: {
    companyName: "",
    businessType: "",
    country: "",
    yearEstablished: "",
    numberOfEmployees: "",
    annualSalesRevenue: "",
    companyWebite: "",
    myCompanyHasNoWebite: Boolean(),
    panNumber: "",
    gstin_Number: "",
    companyDescription: "",
  },
  deliveryAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    latitude: Number(),
    longitude: Number(),
  },
  supplierDetails: {
    supplierId: "",
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    emailId: "",
    phoneNo: "",
    latitude: Number(),
    longitude: Number(),
    panNumber: "",
    gstin_Number: "",
  },
  pickUpAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: Number(),
    latitude: Number(),
    longitude: Number(),
  },
  assetDetails: [
    {
      assetVerticalId: "",
      assetVerticalFriendlyName: "",
      category: "",
      legacyAssetType: "",
      modelId: "",
      cn: "",
      hsn: "",
      labelInstructions: "",
      description: "",
      grade: "",
      origin: "",
      quantity: "",
      unit: "",
      price: "",
      discount: "",
      totalDiscountablePrice: Number(),
    },
  ],
  storageDetails: {
    city: "",
    preferredStartDate: "",
    expectedDurationOfStorage: "",
  },
  requirements: {
    transport: "",
    storageInsurance: "",
    agreement: "",
    storageGuideLineLink: "",
    optionalDocumentLink: "",
    fromDate: "",
    toDate: "",
  },
  totalAmount: Number(),
  paymentMode: "",
  requestType: "",
  timeStamp: getFormattedTimestamp(),
};

const assetbuyrfqreq = {
  rfqId: "",
  proformaInvoiceId: "",
  personalDetails: {
    networkId: "",
    parentId: "",
    username: "",
    no: "",
    siteName: "",
    name: "",
    phoneNo: Number(),
    emailId: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: Number(),
    landmark: "",
    panNumber: "",
    latitude: Number(),
    longitude: Number(),
  },
  companyAdditionalInformation: {
    companyName: "",
    businessType: "",
    country: "",
    yearEstablished: "",
    numberOfEmployees: "",
    annualSalesRevenue: "",
    companyWebite: "",
    myCompanyHasNoWebite: Boolean(),
    panNumber: "",
    gstin_Number: "",
    companyDescription: "",
  },
  deliveryAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  pickUpAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: Number(),
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  supplierDetails: {
    supplierId: "",
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    emailId: "",
    phoneNo: "",
    latitude: Number(),
    longitude: Number(),
    panNumber: "",
    gstin_Number: "",
  },
  assetDetails: [
    {
      assetVerticalId: "",
      assetVerticalFriendlyName: "",
      category: "",
      legacyAssetType: "",
      modelId: "",
      cn: "",
      hsn: "",
      labelInstructions: "",
      description: "",
      grade: "",
      origin: "",
      quantity: "",
      unit: "",
      price: "",
      discount: "",
      totalDiscountablePrice: Number(),
    },
  ],
  requirements: {
    assetPackage: "",
    optionalDocumentLink: "",
    weight: "",
    age: "",
    gender: "",
    orderType: "",
  },
  totalAmount: Number(),
  paymentMode: "",
  requestType: "",
  timeStamp: getFormattedTimestamp(),
};

const whitelabelrequest = {
  personalDetails: {
    networkId: "",
    parentId: "",
    username: "",
    no: "",
    siteName: "",
    name: "",
    phoneNo: Number(),
    emailId: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: Number(),
    landmark: "",
    latitude: Number(),
    longitude: Number(),
    panNumber: "",
  },
  companyAdditionalInformation: {
    companyName: "",
    businessType: "",
    country: "",
    yearEstablished: "",
    numberOfEmployees: "",
    annualSalesRevenue: "",
    companyWebite: "",
    myCompanyHasNoWebite: Boolean(),
    panNumber: "",
    gstin_Number: "",
    companyDescription: "",
  },
  supplierDetails: {
    supplierId: "",
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    emailId: "",
    phoneNo: "",
    latitude: Number(),
    longitude: Number(),
    panNumber: "",
    gstin_Number: "",
  },
  siteAddress: {
    siteId: "",
    siteName: "",
    street: "",
    city: "",
    pincode: Number(),
    state: "",
    country: "",
    latitude: Number(),
    longitude: Number(),
  },
  assetDetails: [
    {
      assetVerticalId: "",
      assetVerticalFriendlyName: "",
      category: "",
      legacyAssetType: "",
      modelId: "",
      assetId: ["0121"], // this field is Required when quantity is one otherwise it is optional.
      cn: "",
      hsn: "",
      labelInstructions: "",
      description: "",
      grade: "",
      origin: "",
      quantity: "",
      unit: "",
      price: "",
      discount: "",
      totalDiscountablePrice: Number(),
    },
  ],
  totalAmount: Number(),
  assetPackage: "",
  paymentMode: "",
  requestType: "",
  timeStamp: getFormattedTimestamp(),
};

export {
  initialState,
  transportasset,
  storageasset,
  assetbuyrfqreq,
  whitelabelrequest,
};
